// extracted by mini-css-extract-plugin
module.exports = {"fnav":"fnav_fnav__1h3ye"};